import {useMultiStyleConfig} from '@chakra-ui/react';
import type {PartsStyleObject} from '@chakra-ui/styled-system';
import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

import {components} from '../../design-tokens/light';

import {inputTheme} from './Input';

const anatomyKeys = [
  `root`,
  `input`,
  `trigger`,
  `viewTrigger`,
  `nextTrigger`,
  `prevTrigger`,
  `table`,
  `tableRow`,
  `tableCell`,
  `content`,
] as const;

type Parts = typeof anatomyKeys;
const {defineMultiStyleConfig, definePartsStyle} = createMultiStyleConfigHelpers(anatomyKeys);

const input = components.colors.components[`form-control`];
const baseStyle = definePartsStyle({
  root: {
    ...inputTheme.baseStyle?.field,
  },
  input: {
    ...inputTheme.baseStyle?.field,
  },
  trigger: {
    // TODO: use from input
    color: input[`icon-default`],
    _hover: {
      color: input[`text-default`],
    },
    _active: {
      color: input[`text-default`],
    },
    _disabled: {
      color: input[`icon-disabled`],
    },
    _focus: {
      color: input[`text-default`],
    },

    paddingInlineEnd: `space-150`,
    paddingInlineStart: `space-150`,
  },
});

const sizes = {
  md: definePartsStyle({
    root: inputTheme.sizes?.md.field,
    input: inputTheme.sizes?.md.field,
  }),

  lg: definePartsStyle({
    root: inputTheme.sizes?.lg.field,
    input: inputTheme.sizes?.lg.field,
  }),
} as const;

export const datePickerTheme = defineMultiStyleConfig({
  baseStyle,
  sizes,
  variants: {},
  defaultProps: {
    size: `lg`,
  },
});

export const useDatePickerStyleConfig = (props?: Parameters<typeof useMultiStyleConfig>[1]) => {
  const path = `DatePicker`;
  // @ts-expect-error: TODO: fix this
  return useMultiStyleConfig(path, props ?? {}) as PartsStyleObject<{keys: Parts}>;
};

export type DatePickerSizes = keyof typeof sizes;
